import addSubscriptions from 'vuex-subscriptions';
import vueTickDebounce from 'vue-tick-debounce';

const debouncedPanelChanged = vueTickDebounce(({ state, dispatch }) => {
  const panels = state.launcher.panels;
  dispatch('interop/panelsChanged', panels);
});

export default addSubscriptions({
  subscriptions: {
    registerPanel: debouncedPanelChanged,
    unregisterPanel: debouncedPanelChanged,
  },
});
